import React, { useState } from 'react'
import Modal from '../../blocks/Modal'
import Button from '../../blocks/Button'
import './PrintModal.scss'
import { useTranslation } from 'react-i18next';

export default function PrintModal(props) {
  const { onClose, stage } = props;

  const [waiting, setWaiting] = useState(false);
  const {t} = useTranslation("badging_report")

  if (stage === 0) { return null; }

  if (stage === 1) {
    return <Modal isOpen={true} renderCloseIcon={false} onClose={onClose}>
      <div className='certPrintModal'>
        <div className='modalContent'>
          <div className='modalTitle'>
            {t("Print Certificates")}
          </div>
          <div className='modalText'>
            {t("award_eligible_badges")}
          </div>
        </div>
        <div className='modalControls'>
          <Button onClick={onConfirm} waiting={waiting}>{t("common:Proceed")}</Button>
          <Button type='secondary' onClick={onClose}>{t("common:Cancel")}</Button>
        </div>
      </div>
    </Modal>
  }

  if (stage === 2) {
    return <Modal isOpen={true} renderCloseIcon={false} onClose={onClose}>
      <div className='certPrintModal'>
        <div className='modalContent'>
          <div className='modalTitle'>
            {t("Certificate Color")}
          </div>
          <div className='modalText'>
            {t("select_certificate_color")}
          </div>
        </div>
        <div className='modalControls'>
          <Button onClick={() => props.onSubmit(true)} waiting={waiting}>{t("Color")}</Button>
          <Button onClick={() => props.onSubmit(false)} waiting={waiting}>{t("Black/White")}</Button>
          <Button type='secondary' onClick={onClose}>{t("common:Cancel")}</Button>
        </div>
      </div>
    </Modal>
  }

  async function onConfirm() {
    setWaiting(true); 
    await props.onConfirm();
    setWaiting(false);
  }
}